import React, { useState } from 'react';
import {
  Button,
  ButtonSize,
  ButtonVariant,
  CmhcIcon,
  CmhcIconSize,
  ToastNotification,
  ToastNotificationVariant
} from '@cmhc-schl/hearth-ui';
import { Box, Typography } from '@mui/material';
import { getInsuredApprovedlenderName } from 'Feature/V2/HbtPortfolioManagement/utils/GetLenderName';
import { MemoizedHbtDataTableCell } from 'Feature/V2/Shared/MemoizedHbtDataTableCell';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import styles from '../styles.module.scss';
import { RequestDetailsSectionProps } from '../types';
import { TableRow } from './tableRow';
import CopyContentToClipBoard from './CopyContentToClipBoard';

export const RequestDetailsSection = ({
  isCollapsed,
  onToggle,
  lenderDetails
}: RequestDetailsSectionProps) => {
  const { t } = useTranslation('HbtPortfolioManagementRequestOverview');
  const [showToaster, setShowToaster] = useState(false);
  const [toaster, setToasterMsg] = useState({
    icon: 'icon_check_circle',
    message: {
      header: t('Copied'),
      subHeader: String(' ')
    }
  });
  const underwritingLender =
    lenderDetails?.underwritingApprovedLenderName ?? lenderDetails?.underwritingLenderName;

  return (
    <>
      <Box className={styles.toasterNotification}>
        <ToastNotification
          dismissMode="autoAndActionable"
          variant={ToastNotificationVariant.INFO}
          open={showToaster}
          header={{ value: toaster.message.header }}
          subHeader={{ value: toaster.message.subHeader }}
          onClose={() => setShowToaster(false)}
          icon={toaster.icon}
        />
      </Box>

      <Box className={`${styles.requestDetailsContainer} ${isCollapsed ? styles.collapsed : ''}`}>
        <Box className={styles.accordionContainer} onClick={onToggle}>
          <Typography variant="h6" className={styles.accordionTitle}>
            {t('Lender')}
          </Typography>
          <Button
            type="button"
            className={styles.toggleButton}
            id={styles.toggleButton}
            name="lender"
            size={ButtonSize.SMALL}
            variant={ButtonVariant.SECONDARY}
            onClick={onToggle}
            leadingIcon={() => (
              <CmhcIcon
                className={styles.accordionIcon}
                size={CmhcIconSize.MEDIUM}
                type={isCollapsed ? 'icon_chevron_up' : 'icon_chevron_down'}
              />
            )}
            text={{
              value: ''
            }}
          />
        </Box>
        <Box className={styles.accordionBody}>
          <Box className={styles.tableContainer}>
            <TableRow
              leftTitle={t('Insured-Approved-Lender-Name')}
              leftValue={() => (
                <CopyContentToClipBoard
                  onSuccess={() => setShowToaster(true)}
                  showClipButton={Boolean(
                    getInsuredApprovedlenderName(
                      lenderDetails?.insuredApprovedLenderName,
                      i18n.language
                    ) ?? ''
                  )}
                  clipboardContent={
                    getInsuredApprovedlenderName(
                      lenderDetails?.insuredApprovedLenderName,
                      i18n.language
                    ) ?? ''
                  }
                >
                  <MemoizedHbtDataTableCell
                    dataValue={String(lenderDetails?.insuredApprovedLenderName?.englishName)}
                    cellContent={
                      <span>
                        {getInsuredApprovedlenderName(
                          lenderDetails?.insuredApprovedLenderName,
                          i18n.language
                        )}
                      </span>
                    }
                  />
                </CopyContentToClipBoard>
              )}
              rightTitle={t('Underwriting-Approved-Lender-Name')}
              rightValue={() => (
                <CopyContentToClipBoard
                  onSuccess={() => setShowToaster(true)}
                  showClipButton={Boolean(
                    getInsuredApprovedlenderName(underwritingLender, i18n.language) ?? ''
                  )}
                  clipboardContent={
                    getInsuredApprovedlenderName(underwritingLender, i18n.language) ?? ''
                  }
                >
                  <MemoizedHbtDataTableCell
                    dataValue={String(underwritingLender?.englishName ?? '')}
                    cellContent={
                      <span>{getInsuredApprovedlenderName(underwritingLender, i18n.language)}</span>
                    }
                  />
                </CopyContentToClipBoard>
              )}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};
